<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-0 pt-5 pt-md-3"
    ></base-header>
    <div class="container-fluid mt-3">
      <tabs :fill="false" class="flex-column flex-md-row">
        <div>
          <tab-pane>
            <span slot="title">
              <i class="ni ni-cloud-upload-96"></i>
              Today
            </span>

            <!-- all categry table -->
            <div class="row mb-5">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    :class="type === 'dark' ? 'bg-transparent' : ''"
                  >
                    <div class="row align-items-center">
                      <div class="col">
                        <h3
                          class="mb-0"
                          :class="type === 'dark' ? 'text-white' : ''"
                        >
                          Quotation Requests
                        </h3>
                      </div>
                      <div class="col text-right">
                        <!-- <base-button type="primary" size="sm" @click="openaddcategory()" icon="fa fa-plus">Add new category</base-button> -->
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <base-table
                      class="table align-items-center table-flush"
                      :class="type === 'dark' ? 'table-dark' : ''"
                      :thead-classes="
                        type === 'dark' ? 'thead-dark' : 'thead-light'
                      "
                      tbody-classes="list"
                      :data="quotesrequestData"
                    >
                      <template slot="columns">
                        <th>S.</th>
                        <th>Project Name</th>
                        <th>Category</th>
                        <th>Sub Category</th>
                        <th>Quantity</th>
                        <th>Buyer</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Attachment/s</th>
                        <th></th>
                      </template>
                      <template slot-scope="{ row, index }">
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{ index + 1 }}.
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{ row.projectplan_id.projectplan_name }}
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{
                              row.business_category_id.business_category_name
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{
                              row.business_subcategory_id
                                .business_subcategory_name
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{ row.quantity }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{ row.created_by.user_public_name }}
                          </p>
                        </td>
                        <td class="budget">
                          <span
                            v-if="getQuoteStatus(row)"
                            :class="getStatusClass(getQuoteStatus(row))"
                            style="display: inline-block; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 600; text-transform: capitalize;"
                          >
                            {{ getQuoteStatus(row) }}
                          </span>
                          <span v-else style="color: #999;">N/A</span>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{ formatDate(row.created_at || row.createdAt) }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="display: block;vertical-align: middle;margin-top: 7px;"
                          >
                            <span
                              v-for="(business_attachments,
                              bidx) in row.business_attachments"
                              :key="bidx"
                              class="d-block"
                            >
                              <a :href="business_attachments" target="_blank"
                                ><i class="fa fa-download mr-2"></i>download</a
                              >
                            </span>
                          </p>
                        </td>
                        <td class="text-right">
                          <base-button
                            type="success"
                            size="sm"
                            icon="fa fa-info"
                            @click="openallquotations(row)"
                          >
                            Vie Quotations
                          </base-button>
                          <base-button
                            type="primary"
                            size="sm"
                            icon="fa fa-info"
                            @click="opencreatequotation(row)"
                          >
                            Create Quotation
                          </base-button>
                        </td>
                      </template>
                    </base-table>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>

          <!-- brands -->
          <tab-pane>
            <span slot="title">
              <i class="ni ni-cloud-upload-96"></i>
              All Quotations
            </span>

            <!-- all Brand table -->
            <div class="row mb-5">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    :class="type === 'dark' ? 'bg-transparent' : ''"
                  >
                    <div class="row align-items-center">
                      <div class="col">
                        <h3
                          class="mb-0"
                          :class="type === 'dark' ? 'text-white' : ''"
                        >
                          All Quotation Submissions
                        </h3>
                      </div>
                      <div class="col text-right">
                        <!-- <base-button type="primary" size="sm" icon="fa fa-plus" @click="openaddbrand()">Add new brand</base-button> -->
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <base-table
                      class="table align-items-center table-flush"
                      :class="type === 'dark' ? 'table-dark' : ''"
                      :thead-classes="
                        type === 'dark' ? 'thead-dark' : 'thead-light'
                      "
                      tbody-classes="list"
                      :data="allquotesData"
                    >
                      <template slot="columns">
                        <th>S.</th>
                        <th>Project Name</th>
                        <th>Category</th>
                        <th>Sub Category</th>
                        <th>Quantity</th>
                        <th>Supplier</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Attachment/s</th>
                        <th></th>
                      </template>
                      <template slot-scope="{ row, index }">
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{ index + 1 }}.
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{
                              row.projectplan_id &&
                              row.projectplan_id.projectplan_name
                                ? row.projectplan_id.projectplan_name
                                : 'N/A'
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{
                              row.business_category_id &&
                              row.business_category_id.business_category_name
                                ? row.business_category_id
                                    .business_category_name
                                : 'N/A'
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <p style="text-transform: capitalize;">
                            {{
                              row.business_subcategory_id &&
                              row.business_subcategory_id
                                .business_subcategory_name
                                ? row.business_subcategory_id
                                    .business_subcategory_name
                                : 'N/A'
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{ row.quantity }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{
                              row.created_by &&
                              row.created_by.business_name_english
                                ? row.created_by.business_name_english
                                : row.created_by &&
                                  row.created_by.user_public_name
                                ? row.created_by.user_public_name
                                : 'N/A'
                            }}
                          </p>
                        </td>
                        <td class="budget">
                          <span
                            v-if="getQuoteStatus(row)"
                            :class="getStatusClass(getQuoteStatus(row))"
                            style="display: inline-block; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 600; text-transform: capitalize;"
                          >
                            {{ getQuoteStatus(row) }}
                          </span>
                          <span v-else style="color: #999;">N/A</span>
                        </td>
                        <td class="budget">
                          <p
                            style="text-transform: capitalize;white-space: normal;"
                          >
                            {{ formatDate(row.created_at || row.createdAt) }}
                          </p>
                        </td>
                        <td class="budget">
                          <p
                            style="display: block;vertical-align: middle;margin-top: 7px;"
                          >
                            <span
                              v-for="(business_attachment,
                              i) in row.business_attachments"
                              :key="i"
                              class="d-block"
                            >
                              <a :href="business_attachment" target="_blank"
                                ><i class="fa fa-download mr-2"></i>download</a
                              >
                            </span>
                          </p>
                        </td>
                        <td class="text-right">
                          <base-button
                            type="success"
                            size="sm"
                            icon="fa fa-info"
                            @click="openallquotations(row)"
                          >
                            View Details
                          </base-button>
                          <base-button
                            type="primary"
                            size="sm"
                            icon="fa fa-plus"
                            @click="opencreatequotation(row)"
                            class="ml-2"
                          >
                            Create Quotation
                          </base-button>
                        </td>
                      </template>
                    </base-table>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
        </div>
      </tabs>
    </div>
    <!-- modal add Category  -->
    <modal :show.sync="model.addcategory">
      <h6 slot="header" class="modal-title" id="modal-title-default">Add</h6>
      <template>
        <form @submit.prevent>
          <div class="">
            <div class="row">
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="Category Name"
                  placeholder="Category Name"
                  input-classes="form-control-alternative"
                  v-model="model.inventory_category_name"
                />
              </div>
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="Category Name Arabic"
                  placeholder="Category Name Arabic"
                  input-classes="form-control-alternative"
                  v-model="model.inventory_category_name_ar"
                />
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-lg-12.">
                <label class="form-control-label">Status</label>
                <select
                  v-model="model.status"
                  aria-describedby="addon-right addon-left"
                  class="form-control form-control-alternative"
                  autocomplete="off"
                >
                  <option>approved</option>
                  <option>disapprove</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button type="primary" id="updatebtn" v-on:click="savecategory()"
          >Save changes</base-button
        >
        <base-button
          type="link"
          class="ml-auto"
          @click="model.addcategory = false"
          >Close
        </base-button>
      </template>
    </modal>
    <!-- modal edit category  -->
    <modal :show.sync="modals.editcategory">
      <h6 slot="header" class="modal-title" id="modal-title-default">Edit</h6>
      <template>
        <form @submit.prevent>
          <div class="">
            <div class="row">
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="Category Name"
                  placeholder="Category Name"
                  input-classes="form-control-alternative"
                  v-model="modals.inventory_category_name"
                />
              </div>
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="Category Name Arabic"
                  placeholder="Category Name Arabic"
                  input-classes="form-control-alternative"
                  v-model="modals.inventory_category_name_ar"
                />
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-lg-12.">
                <label class="form-control-label">Status</label>
                <select
                  v-model="modals.status"
                  aria-describedby="addon-right addon-left"
                  class="form-control form-control-alternative"
                  autocomplete="off"
                >
                  <option>approved</option>
                  <option>disapprove</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          type="primary"
          id="updatebtn1"
          v-on:click="updatecategory()"
          >Save changes</base-button
        >
        <base-button
          type="link"
          class="ml-auto"
          @click="modals.editcategory = false"
          >Close
        </base-button>
      </template>
    </modal>
    <!-- modal add brand  -->
    <modal :show.sync="brandmodel.addbrand">
      <h6 slot="header" class="modal-title" id="modal-title-default">Add</h6>
      <template>
        <form @submit.prevent>
          <div class="">
            <div class="row">
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="brand Name"
                  placeholder="brand Name"
                  input-classes="form-control-alternative"
                  v-model="brandmodel.filter_value"
                />
              </div>
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="brand Name Arabic"
                  placeholder="brand Name Arabic"
                  input-classes="form-control-alternative"
                  v-model="brandmodel.filter_value_ar"
                />
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button type="primary" id="updatebtn3" v-on:click="savebrand()"
          >Save changes</base-button
        >
        <base-button
          type="link"
          class="ml-auto"
          @click="brandmodel.addbrand = false"
          >Close
        </base-button>
      </template>
    </modal>
    <!-- modal edit brand  -->
    <modal :show.sync="brandmodals.editbrand">
      <h6 slot="header" class="modal-title" id="modal-title-default">Edit</h6>
      <template>
        <form @submit.prevent>
          <div class="">
            <div class="row">
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="brand Name"
                  placeholder="brand Name"
                  input-classes="form-control-alternative"
                  v-model="brandmodals.filter_value"
                />
              </div>
              <div class="col-lg-12">
                <base-input
                  alternative=""
                  label="brand Name Arabic"
                  placeholder="brand Name Arabic"
                  input-classes="form-control-alternative"
                  v-model="brandmodals.filter_value_ar"
                />
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button type="primary" id="updatebtn4" v-on:click="updatebrand()"
          >Save changes</base-button
        >
        <base-button
          type="link"
          class="ml-auto"
          @click="brandmodals.editbrand = false"
          >Close
        </base-button>
      </template>
    </modal>

    <!-- view received quotations -->
    <modal :show.sync="viewquotations" modalClasses="modal-lg">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        <span>Quotation Request Details</span>
      </h6>

      <template>
        <form @submit.prevent>
          <div class="container">
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="border rounded p-3">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="mb-2">
                        <span class="font-weight-bold mr-2">Created Date:</span>
                        <span>{{
                          formatDate(
                            quotations.created_at || quotations.createdAt
                          )
                        }}</span>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p class="mb-0">
                        <span class="font-weight-bold mr-2"
                          >Additional Notes:</span
                        >
                        <span>{{ quotations.business_remark }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <h6 class="text-muted mb-2">Material Summary</h6>
                <div class="border rounded p-3">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="mb-2">
                        <span class="font-weight-bold mr-2">Quantity:</span>
                        <span
                          >{{ quotations.quantity }} {{ quotations.unit }}</span
                        >
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p class="mb-0">
                        <span class="font-weight-bold mr-2">Attachments:</span>
                        <span
                          v-for="(business_attachments,
                          index) in quotations.business_attachments"
                          :key="index"
                          class="d-inline-block mr-2"
                        >
                          <a
                            v-if="business_attachments"
                            :href="business_attachments"
                            target="_blank"
                            rel="noopener"
                          >
                            Download
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-3" v-if="quotations.created_by">
                <h6 class="text-muted mb-2">Contact Information</h6>
                <div class="border rounded p-3">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="mb-2">
                        <span class="font-weight-bold mr-2">Buyer:</span>
                        <span>{{
                          quotations.created_by.user_public_name
                        }}</span>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p class="mb-2">
                        <span class="font-weight-bold mr-2">Email:</span>
                        <span>{{ quotations.created_by.user_email }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          type="primary"
          id="updatebtn1"
          @click="viewquotations = false"
          >Close
        </base-button>
      </template>
    </modal>

    <modal :show.sync="createquotation" modalClasses="modal-lg">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Create Quotation Submission
      </h6>
      <template>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-12 mb-3">
              <label class="form-control-label"
                >Select Business User</label
              >
              <select
                v-model="selectedBusinessUserId"
                class="form-control form-control-alternative"
              >
                <option value="">-- Select Business User (Optional) --</option>
                <option
                  v-for="businessUser in availableBusinessUsers"
                  :key="businessUser._id"
                  :value="businessUser._id"
                >
                  {{
                    businessUser.business_name_english ||
                      businessUser.user_public_name
                  }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <base-input
                type="number"
                step="0.01"
                label="Unit Price (Optional)"
                placeholder="Enter unit price"
                v-model="unitprice"
              />
            </div>
            <div class="col-md-6">
              <base-input
                type="number"
                step="0.01"
                label="Total Price (Optional)"
                placeholder="Enter total price or it will be calculated from unit price"
                v-model="totalprice"
                :disabled="!!(unitprice && currentQuote && currentQuote.quantity)"
              />
              <small class="text-muted">
                <span v-if="unitprice && currentQuote && currentQuote.quantity">
                  Auto-calculated: Unit Price × {{ currentQuote.quantity }} = {{ (parseFloat(unitprice || 0) * (currentQuote.quantity || 0)).toFixed(2) }}
                </span>
                <span v-else>Enter manually or provide unit price to auto-calculate</span>
              </small>
            </div>
            <div class="col-md-12">
              <base-input
                type="text"
                label="Delivery Time (Optional)"
                placeholder="e.g., 2 weeks, 1 month"
                v-model="deliverytime"
              />
            </div>
            <div class="col-md-12">
              <label class="form-control-label">Remark</label>
              <textarea
                class="form-control form-control-alternative"
                rows="3"
                placeholder="Enter additional notes or remarks"
                v-model="remark"
              ></textarea>
            </div>
            <div class="col-md-12">
              <label class="form-control-label">
                Attachment <span class="text-danger">*</span>
              </label>
              <div
                class="border-2 border-dashed border-primary rounded-lg p-4 text-center cursor-pointer hover:bg-gray-50 transition-colors"
                @click="triggerFileUpload"
                @dragover.prevent
                @dragenter.prevent
                @drop.prevent="handleDrop"
                :class="{ 'border-red-500': !attachment && submitting, 'opacity-50': uploadingFile }"
                :style="{ pointerEvents: uploadingFile ? 'none' : 'auto' }"
              >
                <div class="flex flex-col items-center">
                  <i v-if="!uploadingFile" class="fa fa-cloud-upload text-4xl text-primary mb-2"></i>
                  <div v-else class="mb-2">
                    <i class="fa fa-spinner fa-spin text-4xl text-primary"></i>
                  </div>
                  <p class="text-sm text-gray-600 mb-1">
                    {{
                      uploadingFile
                        ? 'Uploading file...'
                        : attachment
                        ? 'File uploaded successfully'
                        : 'Click to upload or drag and drop'
                    }}
                  </p>
                  <div v-if="uploadingFile && uploadPercentage > 0" class="w-full mb-2">
                    <div class="w-full bg-gray-200 rounded-full h-2 mb-1">
                      <div 
                        class="bg-primary h-2 rounded-full transition-all duration-300" 
                        :style="{ width: uploadPercentage + '%' }"
                      ></div>
                    </div>
                    <p class="text-xs text-primary font-medium">{{ uploadPercentage }}%</p>
                  </div>
                  <p class="text-xs text-gray-400">
                    Allowed: Images, PDF, DOC, DOCX. Max size: 50MB
                  </p>
                </div>
              </div>
              <div v-if="attachment" class="mt-3">
                <div
                  class="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-3"
                >
                  <div class="flex items-center">
                    <i class="fa fa-check-circle text-green-500 mr-2"></i>
                    <span class="text-sm text-green-700 font-medium">
                      File uploaded: {{ getFileName(attachment) }}
                    </span>
                  </div>
                  <button
                    type="button"
                    class="text-red-500 hover:text-red-700 text-sm font-medium"
                    @click="removeAttachment"
                  >
                    Remove
                  </button>
                </div>
              </div>
              <div v-if="!attachment && submitting" class="mt-2">
                <small class="text-danger"
                  >Attachment is required to create quotation</small
                >
              </div>
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="closeCreateQuotationModal"
        >
          Cancel
        </base-button>
        <base-button
          type="primary"
          @click="submitQuoteSubmission"
          :disabled="!isFormValid || submitting"
        >
          <span v-if="submitting">Submitting...</span>
          <span v-else>Submit</span>
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import VueSwal from 'vue-swal';
import _ from 'lodash';
import { compressImageIfNeeded } from '../utils/imageCompression';
export default {
  name: 'tables',
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      quotesrequestData: [],
      viewquotations: false,
      createquotation: false,
      quotations: [],
      quotesubmission: [],
      allquotesData: [],
      brandData: [],
      currentQuote: null,
      availableBusinessUsers: [],
      selectedBusinessUserId: '',
      unitprice: '',
      totalprice: '',
      deliverytime: '',
      remark: '',
      attachment: '',
      attachmentFile: null,
      submitting: false,
      uploadingFile: false,
      uploadPercentage: 0,
      auth: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-api-key':
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoidGVzdHVzZXIiLCJpYXQiOjE1NDk4OTE1ODQsImV4cCI6MTU4MTQyNzU4NH0.LXjF7LPkGplQj6nWnEgmdyK7GNceoiihf4mKoAmQQqc',
        },
      },
      modals: {
        editcategory: false,
        inventory_category_name: '',
        inventory_category_id: '',
        inventory_category_name_ar: '',
        status: 'approved',
        created_by: 'Admin',
      },
      model: {
        addcategory: false,
        inventory_category_name: '',
        inventory_category_id: '',
        inventory_category_name_ar: '',
        status: 'approved',
        created_by: 'Admin',
      },
      brandmodals: {
        editbrand: false,
        filter_value: '',
        filter_value_ar: '',
        filter_id: '',
        optype: '',
        created_by: 'Admin',
      },
      brandmodel: {
        addbrand: false,
        filter_value: '',
        filter_value_ar: '',
        filter_id: '1j4nzes61mabas2lq',
        optype: 'Add',
        created_by: 'Admin',
      },
    };
  },
  computed: {
    isFormValid() {
      // Only attachment is required
      return !!this.attachment;
    },
  },
  watch: {
    unitprice(newVal) {
      // Auto-calculate total price if unit price is provided and quantity exists
      if (this.currentQuote && newVal && this.currentQuote.quantity) {
        const unitPrice = parseFloat(newVal) || 0;
        const quantity = this.currentQuote.quantity || 0;
        this.totalprice = (unitPrice * quantity).toFixed(2);
      }
      // Don't clear totalprice if user manually entered it
    },
  },
  mounted() {
    console.log(this.auth);

    // Fetch today's quotation requests
    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT +
          'numberOfQuotationEequestsCreatedToday',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': this.auth.headers['x-api-key'],
          },
        }
      )
      .then((response) => {
        console.log('Today quote requests response:', response);
        console.log('response.data:', response.data);
        console.log('response.data.success:', response.data && response.data.success);
        console.log('response.data.details:', response.data && response.data.details);
        console.log('response.data.message:', response.data && response.data.message);
        
        // Handle response properly
        if (response.data) {
          if (response.data.success && response.data.details) {
          // Check if details is an array or a string 'NA'
          if (Array.isArray(response.data.details)) {
            this.quotesrequestData = response.data.details;
              console.log('Data assigned (array):', this.quotesrequestData.length, 'items');
            } else if (response.data.details !== 'NA' && typeof response.data.details === 'object') {
            // If it's a single object, wrap it in an array
            this.quotesrequestData = [response.data.details];
              console.log('Data assigned (single object):', this.quotesrequestData.length, 'items');
          } else {
            // No data available
              console.log('Details is NA or invalid');
            this.quotesrequestData = [];
          }
        } else {
            console.log('No data found for today quotation requests - response structure:', {
              success: response.data.success,
              hasDetails: !!response.data.details,
              message: response.data.message
            });
            this.quotesrequestData = [];
          }
        } else {
          console.log('No response data at all');
          this.quotesrequestData = [];
        }
        
        console.log(
          'quotesrequestData after assignment:',
          this.quotesrequestData.length,
          'items'
        );
      })
      .catch((error) => {
        console.error('Error fetching today\'s quotation requests:', error);
        console.error('Error details:', error.response);
        this.quotesrequestData = [];
      });

    // Fetch all quotation requests till date
    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + 'numberOfRequestsTillDate',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': this.auth.headers['x-api-key'],
          },
        }
      )
      .then((response) => {
        console.log('All quotation requests response:', response);
        console.log('response.data:', response.data);
        console.log('response.data.success:', response.data && response.data.success);
        console.log('response.data.details:', response.data && response.data.details);
        console.log('response.data.message:', response.data && response.data.message);
        
        if (response.data) {
          if (response.data.success && response.data.details) {
            // Ensure details is an array
            this.allquotesData = Array.isArray(response.data.details)
              ? response.data.details
              : [response.data.details];
            console.log('Data assigned to allquotesData:', this.allquotesData.length, 'items');
          } else {
            console.log('No data found for all quotation requests - response structure:', {
              success: response.data.success,
              hasDetails: !!response.data.details,
              message: response.data.message
            });
            this.allquotesData = [];
          }
        } else {
          console.log('No response data at all');
          this.allquotesData = [];
        }
      })
      .catch((error) => {
        console.error('Error fetching all quotation requests:', error);
        console.error('Error details:', error.response);
        this.allquotesData = [];
      });
  },
  methods: {
    getQuoteStatus(row) {
      // Check if business_statuses exists and has entries
      if (row.business_statuses && Array.isArray(row.business_statuses) && row.business_statuses.length > 0) {
        // Count statuses
        const statusCounts = {};
        row.business_statuses.forEach((status) => {
          const s = status.status || 'pending';
          statusCounts[s] = (statusCounts[s] || 0) + 1;
        });
        
        // Return summary if multiple statuses
        const total = row.business_statuses.length;
        const responded = statusCounts['responded'] || 0;
        const viewed = statusCounts['viewed'] || 0;
        const pending = statusCounts['pending'] || 0;
        
        if (responded === total) {
          return 'responded';
        } else if (responded > 0) {
          return `partial (${responded}/${total})`;
        } else if (viewed > 0) {
          return `viewed (${viewed}/${total})`;
        } else {
          return 'pending';
        }
      }
      
      // Fall back to main status field
      return row.status || row.business_user_status || 'pending';
    },
    getStatusClass(status) {
      if (!status) return '';
      
      const statusLower = status.toLowerCase();
      
      if (statusLower.includes('responded') || statusLower === 'approved') {
        return 'badge badge-success';
      } else if (statusLower.includes('viewed')) {
        return 'badge badge-warning';
      } else if (statusLower.includes('pending')) {
        return 'badge badge-info';
      } else if (statusLower.includes('rejected') || statusLower === 'disapproved') {
        return 'badge badge-danger';
      } else if (statusLower.includes('partial')) {
        return 'badge badge-primary';
      } else {
        return 'badge badge-secondary';
      }
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      let parsed = new Date(value);
      if (isNaN(parsed.getTime())) {
        const asNumber = Number(value);
        if (!isNaN(asNumber)) {
          parsed = new Date(asNumber);
        }
      }
      if (isNaN(parsed.getTime())) {
        return value;
      }
      return parsed.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    openallquotations(row) {
      console.log(row);
      this.quotations = row;
      this.quotesubmission = [];
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_quotesubmission',
          { details: { quote_id: row._id, status: 'approved' } },
          this.auth
        )
        .then((response) => {
          console.log('quotesubmission data', response);
          if (response.data.details) {
            this.quotesubmission = response.data.details;
            this.planloader = false;
            // console.log(this.saveditems);
          }
        });
      this.viewquotations = true;
      console.log('quotesubmission data', this.quotesubmission);
    },
    opencreatequotation(row) {
      console.log('Opening create quotation for:', row);
      console.log('Request sendto array:', row.request_sendto);
      this.currentQuote = row;
      this.selectedBusinessUserId = '';
      this.unitprice = '';
      this.totalprice = '';
      this.deliverytime = '';
      this.remark = '';
      this.attachment = '';
      this.attachmentFile = null;
      this.availableBusinessUsers = [];

      // Fetch business users from request_sendto array
      if (row.request_sendto && row.request_sendto.length > 0) {
        // Handle both cases: populated objects or just IDs
        const businessUserIds = row.request_sendto.map(item => {
          // If it's already an object with _id, use that
          if (item && typeof item === 'object' && item._id) {
            return item._id.toString ? item._id.toString() : item._id;
          }
          // Otherwise it's just an ID (string or ObjectId)
          return item && item.toString ? item.toString() : item;
        });
        console.log('Business user IDs to fetch:', businessUserIds);
        this.fetchBusinessUsers(businessUserIds);
      } else {
        console.log('No request_sendto array found');
        VueSwal({
          title: 'No Business Users',
          text: 'This quote request has no business users assigned.',
          icon: 'warning',
        });
        return;
      }

      this.createquotation = true;
    },
    fetchBusinessUsers(userIds) {
      console.log('Fetching all business users and filtering by IDs:', userIds);
      console.log(
        'API Endpoint:',
        process.env.VUE_APP_API_ENDPOINT + 'read_business'
      );
      
      // Normalize userIds to strings for comparison
      const normalizedUserIds = userIds.map(id => 
        id && id.toString ? id.toString() : String(id)
      );
      console.log('Normalized user IDs:', normalizedUserIds);

      // Fetch all business users using read_businessuser_all (returns all without pagination)
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_businessuser_all',
          {
            details: {
              user_type: 'Business',
              user_status: 'approved'
            }
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': this.auth.headers['x-api-key'],
            },
          }
        )
        .then((response) => {
          console.log('All business users response:', response.data);
          console.log('Response success:', response.data && response.data.success);
          console.log('Response details:', response.data && response.data.details);

          if (response.data && response.data.success && response.data.details) {
            const allBusinessUsers = Array.isArray(response.data.details)
              ? response.data.details
              : [response.data.details];

            console.log('All business users count:', allBusinessUsers.length);
            console.log('Sample user ID:', allBusinessUsers[0] && allBusinessUsers[0]._id);

            // Filter business users by the IDs in request_sendto
            // Normalize user._id to string for comparison
            this.availableBusinessUsers = allBusinessUsers.filter((user) => {
              if (!user || !user._id) return false;
              const userId = user._id.toString ? user._id.toString() : String(user._id);
              const isMatch = normalizedUserIds.includes(userId);
              if (isMatch) {
                console.log('Matched user:', {
                  id: userId,
                  name: user.business_name_english || user.user_public_name
                });
              }
              return isMatch;
            });

            console.log(
              'Filtered business users:',
              this.availableBusinessUsers.length,
              'users found'
            );
            console.log('Available business users:', this.availableBusinessUsers);

            if (this.availableBusinessUsers.length === 0) {
              console.warn('No matching business users found. User IDs searched:', normalizedUserIds);
              console.warn('Available user IDs:', allBusinessUsers.map(u => {
                const id = u._id && u._id.toString ? u._id.toString() : String(u._id);
                return { id, name: u.business_name_english || u.user_public_name };
              }));
              VueSwal({
                title: 'No Business Users Found',
                text:
                  'Could not find the business users for this quote request. Please check the console for details.',
                icon: 'warning',
              });
            }
          } else {
            console.log('No business users found in response - response structure:', {
              success: response.data && response.data.success,
              hasDetails: !!(response.data && response.data.details),
              message: response.data && response.data.message
            });
            this.availableBusinessUsers = [];
            VueSwal({
              title: 'Error',
              text: 'Failed to fetch business users. No data returned.',
              icon: 'error',
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching business users:', error);
          console.error('Error response:', error.response);
          console.error('Error message:', error.message);
          this.availableBusinessUsers = [];
          VueSwal({
            title: 'Error',
            text:
              'Failed to fetch business users: ' +
              (error.response && error.response.data && error.response.data.message || error.message || 'Unknown error'),
            icon: 'error',
          });
        });
    },
    triggerFileUpload() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*,.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      input.style.display = 'none';
      document.body.appendChild(input);
      input.click();
      input.addEventListener('change', (e) => {
        this.handleFileUpload(e);
        // Clean up the input element
        if (input.parentNode) {
          input.parentNode.removeChild(input);
        }
      });
      // Also clean up if user cancels
      input.addEventListener('cancel', () => {
        if (input.parentNode) {
          input.parentNode.removeChild(input);
        }
      });
    },
    getFileName(url) {
      if (!url) return '';
      const parts = url.split('/');
      return parts[parts.length - 1] || 'Unknown file';
    },
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        // Validate file type
        const allowedTypes = [
          'image/',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];
        const isValidType = allowedTypes.some((type) =>
          file.type.startsWith(type)
        );

        if (!isValidType) {
          VueSwal({
            title: 'Invalid File Type',
            text: 'Please upload only Images, PDF, DOC, or DOCX files.',
            icon: 'error',
          });
          return;
        }

        // Validate file size (50MB max)
        if (file.size > 50 * 1024 * 1024) {
          VueSwal({
            title: 'File Too Large',
            text: 'File size must be less than 50MB.',
            icon: 'error',
          });
          return;
        }

        // Create a fake event object to reuse the existing handleFileUpload method
        const fakeEvent = {
          target: {
            files: [file],
          },
        };
        this.handleFileUpload(fakeEvent);
      }
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      const allowedTypes = [
        'image/',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
      const isValidType = allowedTypes.some((type) =>
        file.type.startsWith(type)
      );

      if (!isValidType) {
        VueSwal({
          title: 'Invalid File Type',
          text: 'Please upload only Images, PDF, DOC, or DOCX files.',
          icon: 'error',
        });
        return;
      }

      // Validate file size (50MB max)
      if (file.size > 50 * 1024 * 1024) {
        VueSwal({
          title: 'File Too Large',
          text: 'File size must be less than 50MB.',
          icon: 'error',
        });
        return;
      }

      // Compress image if it's larger than 2MB
      const compressedFile = await compressImageIfNeeded(file);
      
      // Upload file using FormData - using the same endpoint as React
      const formData = new FormData();
      formData.append('image', compressedFile);

      this.uploadingFile = true;
      this.uploadPercentage = 0;

      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-api-key': this.auth.headers['x-api-key'],
          },
          timeout: 300000, // 5 minutes timeout for large file uploads
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadPercentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          },
        })
        .then((response) => {
          this.uploadingFile = false;
          this.uploadPercentage = 0;
          if (response.data && response.data.imageUrl) {
            this.attachment = response.data.imageUrl;
            this.attachmentFile = file;
            VueSwal({
              title: 'Success',
              text: 'File uploaded successfully.',
              icon: 'success',
              timer: 2000,
            });
          } else {
            throw new Error('Upload failed - no imageUrl returned');
          }
        })
        .catch((error) => {
          this.uploadingFile = false;
          this.uploadPercentage = 0;
          console.error('File upload error:', error);
          VueSwal({
            title: 'Upload Failed',
            text: 'Failed to upload file. Please try again.',
            icon: 'error',
          });
        });
    },
    removeAttachment() {
      this.attachment = '';
      this.attachmentFile = null;
    },
    closeCreateQuotationModal() {
      this.createquotation = false;
      this.currentQuote = null;
      this.selectedBusinessUserId = '';
      this.unitprice = '';
      this.totalprice = '';
      this.deliverytime = '';
      this.remark = '';
      this.attachment = '';
      this.attachmentFile = null;
      this.availableBusinessUsers = [];
    },
    async uploadFileIfNeeded() {
      return new Promise(async (resolve, reject) => {
        // If there's a file selected but no attachment URL, upload it first
        if (this.attachmentFile && !this.attachment) {
          console.log('Uploading file before submission...');
          
          // Compress image if it's larger than 2MB
          const compressedFile = await compressImageIfNeeded(this.attachmentFile);
          
          const formData = new FormData();
          formData.append('image', compressedFile);

          axios
            .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'x-api-key': this.auth.headers['x-api-key'],
              },
              timeout: 300000, // 5 minutes timeout for large file uploads
            })
            .then((response) => {
              if (response.data && response.data.imageUrl) {
                this.attachment = response.data.imageUrl;
                console.log('File uploaded successfully:', this.attachment);
                resolve(this.attachment);
              } else {
                reject(new Error('Upload failed - no imageUrl returned'));
              }
            })
            .catch((error) => {
              console.error('File upload error:', error);
              reject(error);
            });
        } else {
          // No file to upload or already uploaded
          resolve(this.attachment || null);
        }
      });
    },
    submitQuoteSubmission() {
      // Only attachment is required
        if (!this.attachment) {
        VueSwal({
          title: 'Validation Error',
          text: 'Please upload an attachment file before creating quotation. Attachment is required.',
          icon: 'warning',
        });
        return;
      }

      this.submitting = true;

      // First, ensure file is uploaded if one is selected
      this.uploadFileIfNeeded()
        .then((attachmentUrl) => {
          if (!attachmentUrl) {
            throw new Error('Attachment is required');
          }

          // Build payload with optional fields
          const payload = {
            quote_id: this.currentQuote._id,
            projectplan_id:
              this.currentQuote.projectplan_id._id ||
              this.currentQuote.projectplan_id,
            attachments: [attachmentUrl], // Required
            received_by:
              this.currentQuote.created_by._id || this.currentQuote.created_by,
            business_category_id:
              this.currentQuote.business_category_id._id ||
              this.currentQuote.business_category_id,
            business_subcategory_id:
              this.currentQuote.business_subcategory_id._id ||
              this.currentQuote.business_subcategory_id,
            status: 'approved',
          };

          // Add optional fields only if provided
          if (this.selectedBusinessUserId) {
            payload.created_by = this.selectedBusinessUserId;
          }
          if (this.totalprice) {
            payload.price = parseFloat(this.totalprice);
          }
          if (this.unitprice) {
            payload.unitPrice = parseFloat(this.unitprice);
          }
          if (this.deliverytime) {
            payload.deliveryTime = this.deliverytime;
          }
          if (this.remark) {
            payload.remark = this.remark;
          }

          console.log('Submitting quote submission:', payload);

          // Create quote submission
          return axios.post(
            process.env.VUE_APP_API_ENDPOINT + 'create_quotesubmission',
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': this.auth.headers['x-api-key'],
              },
            }
          );
        })
        .then((response) => {
          console.log('Quote submission response:', response);
          console.log('Response data:', response.data);

          // Check if the submission was successful
          if (!response.data || !response.data.success) {
            throw new Error(
              response.data && response.data.message
                ? response.data.message
                : 'Failed to create quote submission'
            );
          }

          // Update quote status and wait for it to complete
          return this.updateQuoteStatus(
            this.currentQuote._id,
            'responded',
            this.selectedBusinessUserId
          ).then(() => response);
        })
        .then((response) => {
          console.log('All operations completed successfully');

          // Close modal immediately
          this.closeCreateQuotationModal();

          // Show success message
          VueSwal({
            title: 'Success',
            text:
              response.data && response.data.message
                ? response.data.message
                : 'Quote submission created successfully!',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            // Refresh the page after success message is shown
            window.location.reload();
          });
        })
        .catch((error) => {
          console.error('Quote submission error:', error);
          console.error('Error details:', {
            message: error.message,
            response: error.response,
            data:
              error.response && error.response.data
                ? error.response.data
                : undefined,
          });

          let errorMessage =
            'Failed to create quote submission. Please try again.';

          // Check if it's a file upload error
          if (error.message && error.message.includes('Upload failed')) {
            errorMessage =
              'File upload failed. Please try uploading the file again.';
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            // Use the error message from the API response
            errorMessage = error.response.data.message;
          } else if (error.message) {
            // Use the error message from the thrown error
            errorMessage = error.message;
          }

          VueSwal({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });

          // DO NOT close modal on error - keep it open so user can try again
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    updateQuoteStatus(quoteId, status, businessUserId) {
      console.log('Updating quote status:', {
        quoteId,
        status,
        businessUserId,
      });

      const payload = {
        quote_id: quoteId,
        business_user_status: status,
        business_user_id: businessUserId,
      };

      return axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'update_quote', payload, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': this.auth.headers['x-api-key'],
          },
        })
        .then((response) => {
          console.log('Quote status updated successfully:', response.data);
          return response;
        })
        .catch((error) => {
          console.error('Error updating quote status:', error);
          // Still resolve to allow the submission process to continue
          // The status update is important but shouldn't block the main flow
          return Promise.resolve({});
        });
    },
    opencategory: function(tcdata) {
      console.log(tcdata);
      this.modals.editcategory = true;
      this.modals.inventory_category_id = tcdata.inventory_category_id;
      this.modals.inventory_category_name = tcdata.inventory_category_name;
      this.modals.inventory_category_name_ar =
        tcdata.inventory_category_name_ar;
      this.modals.status = tcdata.status;
      this.modals.created_by = tcdata.created_by;
      console.log(this.modals);
    },
    openaddcategory: function() {
      this.model.addcategory = true;
    },
    openaddbrand: function() {
      this.brandmodel.addbrand = true;
      this.brandmodel.filter_id = this.brandData.filter_id;
    },
    openbrand: function(tcdata) {
      console.log(tcdata);
      this.brandmodals.editbrand = true;
      this.brandmodals.delete_value = tcdata.value_en;
      this.brandmodals.delete_value_ar = tcdata.value_ar;
      this.brandmodals.filter_value = tcdata.value_en;
      this.brandmodals.filter_value_ar = tcdata.value_ar;
      this.brandmodals.filter_id = this.brandData.filter_id;
      this.brandmodals.optype = 'Add';
      console.log(this.brandmodals);
    },

    savecategory() {
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'create_inventory_category',
          querystring.stringify({
            inventory_category_name: this.model.inventory_category_name,
            inventory_category_name_ar: this.model.inventory_category_name_ar,
            status: this.model.status,
            created_by: this.model.created_by,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          document.getElementById('updatebtn').classList.remove('btn-primary');
          document.getElementById('updatebtn').classList.add('btn-success');
          document.getElementById('updatebtn').innerHTML = this.message;
          setTimeout(function() {
            document
              .getElementById('updatebtn')
              .classList.remove('btn-success');
            document.getElementById('updatebtn').classList.add('btn-primary');
            document.getElementById('updatebtn').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },

    updatecategory() {
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_inventory_category',
          querystring.stringify({
            inventory_category_id: this.modals.inventory_category_id,
            inventory_category_name: this.modals.inventory_category_name,
            inventory_category_name_ar: this.modals.inventory_category_name_ar,
            status: this.modals.status,
            created_by: this.modals.created_by,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          document.getElementById('updatebtn1').classList.remove('btn-primary');
          document.getElementById('updatebtn1').classList.add('btn-success');
          document.getElementById('updatebtn1').innerHTML = this.message;
          setTimeout(function() {
            document
              .getElementById('updatebtn1')
              .classList.remove('btn-success');
            document.getElementById('updatebtn1').classList.add('btn-primary');
            document.getElementById('updatebtn1').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },
    deletecategory(row) {
      const querystring = require('querystring');
      swal({
        title: 'Are you sure?',
        text: "wan't to delete",
        icon: 'warning',
        buttons: { cancel: true, confirm: true },
      }).then((result) => {
        if (result) {
          console.log('result cloud', result);
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'delete_inventory_category/',
              querystring.stringify({
                inventory_category_id: row.inventory_category_id,
                created_by: this.model.created_by,
              }),
              this.auth1
            )
            .then((response) => {
              console.log(response);
              swal({
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                icon: 'success',
              }).then((result) => {
                console.log(result);
                window.location.reload();
              });
            });
        }
      });
    },
    savebrand() {
      const querystring = require('querystring');
      console.log(this.brandmodel);
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter',
          querystring.stringify({
            filter_id: this.brandmodel.filter_id,
            filter_value: this.brandmodel.filter_value,
            filter_value_ar: this.brandmodel.filter_value_ar,
            optype: this.brandmodel.optype,
            created_by: this.brandmodel.created_by,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          document.getElementById('updatebtn3').classList.remove('btn-primary');
          document.getElementById('updatebtn3').classList.add('btn-success');
          document.getElementById('updatebtn3').innerHTML = this.message;
          setTimeout(function() {
            document
              .getElementById('updatebtn3')
              .classList.remove('btn-success');
            document.getElementById('updatebtn3').classList.add('btn-primary');
            document.getElementById('updatebtn3').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },

    updatebrand() {
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter',
          querystring.stringify({
            filter_id: this.brandmodals.filter_id,
            filter_value: this.brandmodals.delete_value,
            filter_value_ar: this.brandmodals.delete_value_ar,
            optype: 'Remove',
            created_by: this.brandmodals.created_by,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter',
              querystring.stringify({
                filter_id: this.brandmodals.filter_id,
                filter_value: this.brandmodals.filter_value,
                filter_value_ar: this.brandmodals.filter_value_ar,
                optype: this.brandmodals.optype,
                created_by: this.brandmodals.created_by,
              }),
              this.auth1
            )
            .then((response) => {
              console.log();
            });
          document.getElementById('updatebtn4').classList.remove('btn-primary');
          document.getElementById('updatebtn4').classList.add('btn-success');
          document.getElementById('updatebtn4').innerHTML = this.message;
          setTimeout(function() {
            document
              .getElementById('updatebtn4')
              .classList.remove('btn-success');
            document.getElementById('updatebtn4').classList.add('btn-primary');
            document.getElementById('updatebtn4').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },
    deletebrand(row) {
      const querystring = require('querystring');
      console.log(row);

      swal({
        title: 'Are you sure?',
        text: "wan't to delete",
        icon: 'warning',
        buttons: { cancel: true, confirm: true },
      }).then((result) => {
        if (result) {
          console.log('result cloud', result);
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter/',
              querystring.stringify({
                filter_id: this.brandmodals.filter_id,
                filter_value: row.value_en,
                filter_value_ar: row.value_ar,
                optype: 'Remove',
                created_by: this.brandmodals.created_by,
              }),
              this.auth1
            )
            .then((response) => {
              console.log(response);
              swal({
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                icon: 'success',
              }).then((result) => {
                console.log(result);
                window.location.reload();
              });
            });
        }
      });
    },
    // sortArrays(arrays) {
    //     return _.orderBy(arrays, 'inventory_category_name', 'asc');
    // },
    sortbrands(arrays) {
      return _.orderBy(arrays, 'value_en', 'asc');
    },
  },
};
</script>
